<template>
    <ui-select-2
        v-model="selected"
        :label="label"
        :data="options"
        :loading="loader"
        :disabled="disabled"
        :return-value="returnValue"
        :text-items="['quant_corretores', 'quant_gerentes']"
        :before-text-item="['Corretores:', 'Gerentes:']"
        :multiple="multiple"
        :search-event="eventHandlerName"
        cover="logo"
        ajax-search
        item-label="label"
    />    
</template>

<script>
import { uiSelect2 } from '@/components/ui/form'
import { storage } from '@/services/storage'
import { team } from '@/services/axios'

import helpers from '@/mixins/helpers'
import axios from 'axios'
export default {
	name: 'ui-team-selector',
	components: {
		uiSelect2
	},
	mixins: [helpers],
	props: {
		// Bind da v-model
		// eslint-disable-next-line vue/require-prop-types
		value: {
			required: true,
		},
		// Define o texto sobre o select2 do componente.
		label: {
			type: String,
			required: false,
			default: 'Equipe:'
		},
		// Define se o select2 está desabilitado.
		disabled: {
			type: Boolean,
			required: false,
			default: false
		},
		// Define se o select2 retornará uma chave do objeto ou o objeto.
		returnValue: {
			type: String,
			required: false,
			default: 'object'
		},
		// Define se o select2 aceitará seleção multipla
		multiple: {
			type: Boolean,
			required: false,
			default: false
		},
		/**
		 * Se ativado, o componente responderá ao evento "team-selector"
		 */
		withInitValue: {
			type: Boolean,
			required: false,
			default: false
		},
		/**
		 * Define o nome do componente para event handler
		 */
		name: {
			type: String,
			required: true,
			default: ''
		},
		/**
		 * Ativa se mantem o dado no localStorage
		 */
		searchSaved: {
			type: Boolean,
			default: false
		},

		modelSaved: {
			type: Array,
			default: () => []
		}

	},
	data() {
		return {
			selected: null,
			loader: false,
			options: [],

			page: 1,
			totalPages: 1,
			cancelToken: null,
			searchTeamSelector: null
		}
	},
	computed: {
		eventHandlerName() {
			return "teams-" + this.name
		}
	},

	watch: {
		value(newVal) {
			if (!newVal || newVal.length === 0) {
				this.options = []
				this.selected = null
				this.$emit('input', null)
			}
		},

		selected: {
			handler(newVal) {
				this.$emit('input', newVal)
			},

			deep: true,
		},
	},
	mounted() {
		this.selected = this.modelSaved.length > 0 ? this.modelSaved : null
		if(this.searchSaved) {
			let data = JSON.parse(storage.get(this.name))
			let search = data?.search ? data.search : ''
			this.$root.$emit('set-input-search-select-v2', search )
		}

		this.$root.$on('search-team-selector',() => {
			if(this.searchTeamSelector) storage.set(this.name, JSON.stringify(this.searchTeamSelector))
		})

		this.$root.$on('select2-ajax-search-teams-' + this.name, 
			/**
			 * Recebe o valor do input do select2 e busca as equipes.
			 * @param {Object} data
			 */
			async (data) => {
				/**
				 * Verifica em qual página está, atualizando os parametros da busca.
				 */
				 await this.searchChangeEvent(data)
				 this.searchTeamSelector = this.searchSaved  ? data : null
			})

		this.$root.$on('team-selector-' + this.name, async (data) => {			
			if (!this.withInitValue)
				return

			if (!data || !data.team_name || !data.team_id)
				return

			// Search with name
			this.options = await this.loadOptions(data.team_name)

			// Select the current data
			this.selected = this.options.find((option) => option.id == data.team_id)
		})
	},
	beforeDestroy() {
		this.$root.$off('select2-ajax-search-teams-' + this.name)
		this.$root.$off('team-selector-' + this.name)
		this.$root.$off('search-team-selector')
		this.$root.$off('clear-search-team-selector')
	},
	methods: {
		//chama o change event
		async searchChangeEvent(data) {
			if (!data.nextPage) {
					this.page = 1
					this.totalPages = null
				} else {
					if (this.page > this.totalPages) this.page = this.page + 1
				}

				let response = []
				if (this.page <= this.totalPages) return 

				// Verifica o cancelToken, caso exista cancela o request aberto e reinicia o processo.
				// caso não exista inicia um request.
				if (this.cancelToken) {
					this.cancelToken.cancel()
					this.cancelToken = axios.CancelToken.source()
					response = await this.loadOptions(data.search)
				}else{
					this.cancelToken = axios.CancelToken.source()
					response = await this.loadOptions(data.search)
				}

				if (data.nextPage) {
					this.options = this.options.concat(response)
				} else {
					this.options = response
				}
		},
		/**
		 * Carrega as opções do select2.
		 * @param {String} search
		 */
		async loadOptions(search) {
			try {
				this.loader = true

				let params = {
					page: this.page,
					q: search,
					per_page: 50,
				}

				let token = this.cancelToken ? this.cancelToken.token : null
				const { data } = await team.getAll('/search/true', params, {
					cancelToken: token
				})

				this.loader = false

				return data.data.map(e => {
					e.cover = this.getImgCDN(e.logo)
					e.label = e.name

					return e
				})
			} catch (error) {
				return []
			}
		}
	}
}
</script>
<style lang="stylus" scoped>
	@import 'styles.styl'
</style>